<script>
    import constants from '@/constants/index.js';


    export default {
        methods: {
            async startGlobalSearch() {
                this.closeGlobalSearch();

                const storeProvider = this.$store.getters.CURRENT_PROVIDER;
                const provider = storeProvider === 'all' ? null : storeProvider;
                if (provider == null) this.$store.commit('SELECT_PROVIDER', null);
                const storeGame = this.$store.getters.CURRENT_GAME;
                const game = storeGame === 'all' ? null : storeGame;
                if (game == null) this.$store.commit('SELECT_GAME', null);
                const storeAssetType = this.$store.getters.CURRENT_ASSET_TYPE;
                const assetType = storeAssetType === 'all' ? null : storeAssetType;
                const storeFileStatus = this.$store.getters.CURRENT_FILE_STATUS;
                const fileStatus = storeFileStatus === 'all' ? null : storeFileStatus;
                const storeAdditionalStatus = this.$store.getters.CURRENT_ADDITIONAL_STATUS
                const additionalStatus = storeAdditionalStatus === 'all' ? null : storeAdditionalStatus;

                this.$router.push({
                    name: constants.ROUTER_NAME.FILEEDIT,
                    query: {
                        providerID: provider,
                        gameID: game,
                        assetTypeID: assetType,
                        fileStatus: fileStatus,
                        additionalStatus: additionalStatus,
                        filter: this.$store.getters.SELECT_FILTER,
                        tag: this.$store.getters.SELECT_TAG,
                        fileID: this.$store.getters.CURRENT_FILE_ID,
                    }
                });
            },
            async closeGlobalSearch() {
                await this.$store.commit('IS_SHOW_GLOBAL_SEARCH', false);
            },
            async clearTag() {
                await this.$store.commit('SELECT_FILTER', []);
            } 
        },
    }
</script>


<template>
    <div>
        <button 
            class="button_blue_100 mr_10"
            @click="startGlobalSearch"
        >
            Search
        </button>
        <button 
            @click="clearTag"
            class="button_blue_100"
        >
            Clear
        </button>
        <button
            @click="closeGlobalSearch"
            class="close_button button_blue_100 mr_10"
        >
            Close
        </button>
    </div>
</template>